import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/utils';

const LANGS = ['uk', 'en'] as const;
type Lang = (typeof LANGS)[number];

export default function LanguageSwitch({ className }: { className?: string }) {
  const { i18n, t } = useTranslation('common');
  const active = (i18n.language.split('-')[0] as Lang) ?? 'uk';

  return (
    <div
      role="group"
      aria-label={t('language.label')}
      className={cn('inline-flex rounded-md border bg-card p-0.5', className)}
    >
      {LANGS.map((lang) => {
        const isActive = lang === active;
        return (
          <button
            key={lang}
            type="button"
            aria-pressed={isActive}
            onClick={() => void i18n.changeLanguage(lang)}
            className={cn(
              'rounded px-2 py-1 text-xs font-medium uppercase tracking-wide transition-colors',
              isActive
                ? 'bg-primary text-primary-foreground'
                : 'text-muted-foreground hover:bg-accent hover:text-accent-foreground',
            )}
          >
            {t(`language.${lang}`)}
          </button>
        );
      })}
    </div>
  );
}
